import styled from "style/styled-components";

const GrayText = styled.span<{ isBlack?: boolean }>`
  color: ${({ theme, isBlack }) =>
    isBlack ? theme.color.foreground.primary : theme.color.foreground.tertiary};
`;

export default GrayText;
